export default __webpack_public_path__ + "static/Quickinstallation_IN-6001_07-0edad4bc37745c9849cd126db6ed9717.webp";